import type { Platform } from '../entities/wifi';
import type {
  IWifiConnection,
  IWifiAppInfo,
  PostWifiConnection,
  ResGetWifiConnections
} from "../types/api-types";
import { BaseOrganizationEndpoints } from "./base";

export class Wifi extends BaseOrganizationEndpoints {
  /*
   * Returns all wifi connections in the organization
   */
  async getWifiConnections() {
    return await this.requestWithStatus<ResGetWifiConnections>(
      "GET",
      "/v1/wifi/connections"
    );
  }

  /*
   * Returns details for a single wifi connection in the organization
   */
  async getWifiConnection(wifiConnectionId: string) {
    return await this.requestWithStatus<IWifiConnection>(
      "GET",
      `/v1/wifi/connections/${wifiConnectionId}`
    );
  }

  /*
   * Updates an existing wifi connection in the organization
   */
  async updateWifiConnection(
    wifiConnectionId: string,
    body: PostWifiConnection
  ) {
    return await this.requestWithStatus<IWifiConnection>(
      "PUT",
      `/v1/wifi/connections/${wifiConnectionId}`,
      body
    );
  }

  /*
   * Creates a wifi connection in the organization
   */
  async createWifiConnection(body: PostWifiConnection) {
    return await this.requestWithStatus<IWifiConnection>(
      "POST",
      "/v1/wifi/connections",
      body
    );
  }

  /*
   * Deletes a wifi connection in the organization
   */
  async deleteWifiConnection(wifiConnectionId: string) {
    return await this.requestWithStatus<void>(
      "DELETE",
      `/v1/wifi/connections/${wifiConnectionId}`
    );
  }

  async getDownloadInfo(os: Platform) {
    return await this.requestWithStatus<IWifiAppInfo>(
      "GET",
      `/v1/wifi/app?os=${os}`
    );
  }
}
